/* eslint-disable quotes */
import { compact, get } from 'lodash/fp'
import { createSectionCreator, createField } from './utils'
import { POLICY_DELIVERY_BY_EMAIL } from 'e-submission/domain/data-model/constants'

const policyDeliveryField = (app, id) => {
  const isPolicyDeliveryByEmail = get('insured.isPolicyDeliveryByEmail.value')(app)
  let deliveryByEmailInfo = ''
  if (isPolicyDeliveryByEmail) {
    deliveryByEmailInfo = (
      <>
        <b className="text-green">กรมธรรม์จะถูกจัดส่งทางอีเมลเท่านั้น</b>
        <br />
        <label className="text-green">
          ขอบคุณที่ร่วมเป็นส่วนหนึ่งของการลดกระดาษ และร่วมปลูกต้นไม้ 1 ต้น เพื่อโลกที่ดีขึ้นของเรา
        </label>
      </>
    )
  } else {
    deliveryByEmailInfo = 'กรมธรรม์ประกันชีวิตจะถูกจัดส่งไปยังท่านทางไปรษณีย์ตามที่อยู่ที่ท่านได้ระบุไว้'
  }

  return compact([
    createField('insured.isPolicyDeliveryByEmail', [
      {
        id: 'insured.isPolicyDeliveryByEmail',
        label: 'ผู้ขอเอาประกันประสงค์ขอเลือกรับกรมธรรม์ในรูปแบบอิเล็กทรอนิกส์',
        c: 'RadioButton',
        required: true,
        p: {
          mergeState: (state, app) => {
            const isPolicyDeliveryByEmail = get('insured.isPolicyDeliveryByEmail.value')(app)
            return {
              options: [POLICY_DELIVERY_BY_EMAIL.HAVE, POLICY_DELIVERY_BY_EMAIL.NOT_HAVE],
              infoMessage: deliveryByEmailInfo,
              customStyleInfoMessage: isPolicyDeliveryByEmail ? 'info-message-green' : '',
            }
          },
        },
      },
    ]),
  ])
}

export const PolicyDeliverySection = createSectionCreator(policyDeliveryField)
